import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { SettingsNewsroomMediaRequestDetailsQuery } from '@custom/schema';

export const useSettingsNewsroomMediaRequestDetailsQuery = () =>
  useStaticQuery(graphql(SettingsNewsroomMediaRequestDetailsQuery));
